/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';

import {OngoingPayrollsService} from '../../+payrolls/ongoing/ongoing-payrolls.service';
import {TimeModule} from '../../+payrolls/prepare/time/time.module';
import {FilesModule} from '../files/files.module';
import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';

import {TeamsFilterComponent} from './teams-filter/teams-filter.component';
import {TeamsListEmployeeComponent} from './teams-list-employee/teams-list-employee.component';
import {TeamsService} from './teams.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    UserModule,
    UiModule,
    PipesModule,
    ModalModule,
    FilesModule,
    TimeModule,
    NgxMaskDirective
  ],
  declarations: [
    TeamsListEmployeeComponent,
    TeamsFilterComponent
  ],
  exports: [
    TeamsListEmployeeComponent,
    TeamsFilterComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class TeamsSharedModule {
  public static forRoot(): ModuleWithProviders<TeamsSharedModule> {
    return {
      ngModule: TeamsSharedModule,
      providers: [
        TeamsService,
        OngoingPayrollsService
      ]
    };
  }
}
